export const selectedCountry = {
  placeholder: "Land auswählen",
};
